module.exports = __webpack_public_path__ + "img/ring_g_skip_null_0@3x.5686ea8c.png";